import invariant from 'tiny-invariant'

// we can use the bangs here to force the string type, because of the invariants below
const MAYBE_CF_URL = process.env.VITE_CF_URL ?? process.env.NEXT_PUBLIC_CF_URL
const MAYBE_LFS_URL = process.env.VITE_LFS_URL ?? process.env.NEXT_PUBLIC_LFS_URL

invariant(
  MAYBE_CF_URL,
  'VITE_CF_URL or NEXT_PUBLIC_CF_URL is required within studio/src/config/env',
)
invariant(
  MAYBE_LFS_URL,
  'VITE_LFS_URL or NEXT_PUBLIC_LFS_URL is required within studio/src/config/env',
)

export const CF_URL = MAYBE_CF_URL
export const LFS_URL = MAYBE_LFS_URL
